<div id="ftd-header" class="ftd-header" [ngClass]="{'ftd-header--sub': !showSubMenu , 'ftd-header--hide': hideMenuScroll}" >
  
  <div id="ftd-header-main" class="ftd-header-content" [ngClass]="{'ftd-header-content--no-prime': !countryConfig.isPrimeActive}" [ngStyle]="{'background-color': colorHeader}" >

    <div id="ftd-header-see-more" class="ftd-header-content-menu" (click)="handleDeparments('menu')"  >
      <img src="assets/svg/icon-menu.svg" alt="menu">
      <span class="ftd-header-content-menu__title"> Más categorías </span>
      <app-icons [type]="'arrow-fill'"></app-icons>
    </div>
    
    <div class="ftd-header-content-item" *ngFor="let item of itemsMenu; let position = index">
      <a [id]="'ftd-header-main-item-'+position" class="ftd-header-content-item__title" [routerLink]="item.path" rel="noopener noreferrer" (click)="showDeparments = false">
        <img [src]="item.img" [alt]="item.alt">
        <span class="ftd-header-content-item__title--space">{{item.title}}</span>
      </a>
    </div>
    
    <div class="ftd-header-content-prime" *ngIf="countryConfig.isPrimeActive">
      <app-prime-flag ></app-prime-flag>
    </div>
  
  </div>

  <div id="ftd-header-sub" class="ftd-header-sub" *ngIf="showSubMenu">
    <ul class="ftd-header-sub-items">
      <li  class="ftd-header-sub-items__item" *ngFor="let item of itemsSubMenu; let positionSub = index" (click)="!item.redirect ? handleDeparments('subMenu', item): showDeparments = false" [id]="'ftd-header-sub-main-item-'+positionSub">
        <a [id]="'ftd-header-sub-item-'+item.id" class="ftd-header-sub-items__item--link" [routerLink]="item.path" rel="noopener noreferrer" *ngIf="item.redirect">
          {{item.title}}
        </a>
        <div class="ftd-header-sub-items__item--link" *ngIf="!item.redirect">
          {{item.title}}
        </div>
      </li>
    </ul>
  </div>

</div>

<section id="ftd-header-deparments" class="ftd-departments" *ngIf="showDeparments" [ngClass]="{'ftd-departments--sub': showDeparmentsFrom === 'subMenu'}">

  <div id="ftd-header-deparments-background" class="ftd-departments-background" (click)="showDeparments = false"></div>

  <div id="ftd-header-deparments-main" class="ftd-departments-content">

    <div class="ftd-departments-content-s-1">
      <ul class="ftd-departments-content-s-1-list">
        <li class="ftd-departments-content-s-1-list-item" *ngFor="let item of itemsDeparments"  (mouseenter)="activeDeparment(item)" [id]="'ftd-header-deparments-main-item-'+item.id" >
          <a  class="ftd-departments-content-s-1-list-item__link" [routerLink]="item.path"rel="noopener noreferrer" [ngStyle]="{'background-color': item.active ? '#ffffff' : ''}" (click)="showDeparments = false">
            <div class="ftd-departments-content-s-1-list-item__active" [ngStyle]="{'background-color': item.active ? item.color : ''}"></div>
            <div class="ftd-departments-content-s-1-list-item__title">
              <img class="ftd-departments-content-s-1-list-item__image" [src]="item.image" [alt]="item.name">
              <span class="ftd-departments-content-s-1-list-item__title--text" [ngStyle]="{'color': item.active ? item.color : '', 'font-weight': item.active ? '600' : ''}">{{item.name}}</span>
            </div>
            <div class="ftd-departments-content-s-1-list-item__icon"> 
              <app-icons [type]="'arrow-simple'" [color]="item.active ? item.color :'#000'" [custom]="'slim'"></app-icons>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="ftd-departments-content-s-2" *ngIf="showListCategories">
      <div class="ftd-departments-content-items">        
        <div class="ftd-departments-content-items-main">
          
          <div class="ftd-departments-content-items-main-head" id="ftd-header-deparment-main-title">
            <img class="ftd-departments-content-items-main-head__image" [src]="departmentActive.image" [alt]="departmentActive.name">
            <span class="ftd-departments-content-items-main-head__title" [ngStyle]="{'color': departmentActive.active ? departmentActive.color : ''}">{{departmentActive.name}}</span>
            <a class="ftd-departments-content-items-main-head__link" [routerLink]="departmentActive.path"rel="noopener noreferrer" (click)="showDeparments = false">Ver todo</a>
          </div>

          <div class="ftd-departments-content-items-main-body">  
            <ul>
              <li class="ftd-departments-content-items-main-body-list" *ngFor="let categorie of departmentActive.categories" (mouseenter)="activeCategorie(categorie)" [id]="'ftd-header-categorie-main-item-'+categorie.id">
                <a class="ftd-departments-content-items-main-body-list__link" [ngStyle]="{'color': categorie.active ? departmentActive.color : '', 'font-weight': categorie.active ? '600' : '' }"  [routerLink]="categorie.path" rel="noopener noreferrer" (click)="showDeparments = false" >{{categorie.name}}</a>
                <app-icons class="ftd-departments-content-items-main-body-list__icon" [type]="'arrow-simple'" [color]="categorie.active ? departmentActive.color :'#000'" [custom]="'slim'"></app-icons>
              </li>
            </ul>
          </div>
        
        </div>
      </div>
    </div>

    <div class="ftd-departments-content-s-3" *ngIf="showListSubCategories">
      <div class="ftd-departments-content-items">
        <div class="ftd-departments-content-items-main">
            
          <div class="ftd-departments-content-items-main-head" id="ftd-header-categorie-main-title">
            <span class="ftd-departments-content-items-main-head__title" [ngStyle]="{'color': categorieActive.active ? departmentActive.color : ''}">{{categorieActive.name}}</span>
            <a class="ftd-departments-content-items-main-head__link" [routerLink]="categorieActive.path"rel="noopener noreferrer" (click)="showDeparments = false">Ver todo</a>
          </div>
          
          <div class="ftd-departments-content-items-main-body">
            <ul>
              <li class="ftd-departments-content-items-main-body-list" *ngFor="let subCategorie of categorieActive.subCategories" (mouseenter)="subCategorie.active = true" (mouseleave)="subCategorie.active = false" [id]="'ftd-header-sub-categorie-main-item-'+subCategorie.id">
                <a class="ftd-departments-content-items-main-body-list__link" [ngStyle]="{'color': subCategorie.active ? departmentActive.color : '', 'font-weight': subCategorie.active ? '600' : '' }"  [routerLink]="subCategorie.path"rel="noopener noreferrer" (click)="showDeparments = false">{{subCategorie.name}}</a>
              </li>
            </ul>
          </div>
        
        </div>
      </div>
    </div>

    <div class="ftd-departments-content-s-4" *ngIf="showListBrands">
      <div class="ftd-departments-content-items">
        <div class="ftd-departments-content-items-main">
            
          <div class="ftd-departments-content-items-main-head" >
            <span class="ftd-departments-content-items-main-head__title" [ngStyle]="{'color': departmentActive.active ? departmentActive.color : ''}">Marcas recomendadas</span>
            <a class="ftd-departments-content-items-main-head__link" [routerLink]="departmentActive.brandRecommendedPath" rel="noopener noreferrer" (click)="showDeparments = false">Ver todo</a>
          </div>
          
          <div class="ftd-departments-content-items-main-body" [ngClass]="{'ftd-departments-content-items-main-body--footer': departmentActive.brandRecommendedImagePromo}">
            <ul>
              <li class="ftd-departments-content-items-main-body-list" *ngFor="let brand of departmentActive.brandRecommended" (mouseenter)="brand.active = true" (mouseleave)="brand.active = false" [id]="'ftd-header-brand-main-item-'+brand.id" >
                <a class="ftd-departments-content-items-main-body-list__link" [ngStyle]="{'color': brand.active ? departmentActive.color : '', 'font-weight': brand.active ? '600' : '' }"  [routerLink]="brand.path" rel="noopener noreferrer" (click)="showDeparments = false">{{brand.name}}</a>
              </li>
            </ul>
          </div>

          <div class="ftd-departments-content-items-main-footer" *ngIf="departmentActive.brandRecommendedImagePromo">
            <a [href]="departmentActive.brandRecommendedImagePromoPath">
              <img class="ftd-departments-content-items-main-footer__image" [src]="departmentActive.brandRecommendedImagePromo" alt="brandRecommendedAlt" srcset="">
            </a>
          </div>
        
        </div>
      </div>
    </div>

    <div class="ftd-departments-content-close" (click)="showDeparments = false">
      <app-icons [type]="'close'" [color]="'#979797'" [custom]="'xs'"></app-icons>
    </div>

  </div>
  


</section>